import React from "react";
import { createUser, updateUser } from "./authService";
import { getMailAccountData } from "../alert/mailRecipientService";
import { showWarningToast } from "../validation/ToastContainer";

export const CardTypes = {
    CREATE: "CREATE",
    EDIT: "EDIT"
}

export class UserCardService {

    constructor(cardType, handleClose, loggedUserId) {
        this.cardType = cardType || CardTypes.CREATE;
        this.handleClose = handleClose;
        this.loggedUserId = loggedUserId;
    }

    getHeader = () => {
        return (
            <div className="logo text-center">
                {CardTypes.CREATE === this.cardType ? 'New' : 'Edit'} User
            </div>
        )
    }

    getSubmitButton = (data, disabled) => {

        if (CardTypes.CREATE === this.cardType) {
            return (
                <div className="form-group text-center margin-top-one-five">
                    <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                        e.preventDefault();
                        this.onCreate(data);
                    }} disabled={disabled}>Create
                    </button>
                </div>
            )
        } else {
            return (
                <>
                    <div className="form-group text-center margin-top-one-five">
                        <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                            e.preventDefault();
                            this.onSave(data);
                        }} disabled={disabled}>Save
                        </button>
                    </div>
                    {data.id === this.loggedUserId &&
                        <div className="text-center text-warning mb-1">
                            You will be logged out after any changes
                        </div>
                    }
                </>
            )
        }
    }

    onCreate = async (data) => {
         //Check 'Mail Account Settings' is configured
        if (data.enableOtp) {
            const account = await getMailAccountData();
            if (!account || !Object.keys(account).length) {
                return showWarningToast('No Mail Account Settings Exist!', 'Configure Mail Settings', 'aborted');
            }
         }
        await createUser(data);
        this.handleClose(true);
    }

    onSave = async (data) => {
         //Check 'Mail Account Settings' is configured
         if (data.enableOtp) {
            const account = await getMailAccountData();
            if (!account || !Object.keys(account).length) {
                return showWarningToast('No Mail Account Settings Exist!', 'Configure Mail Settings', 'aborted');
            }
         }
         
        await updateUser(data);
        this.handleClose(true);
        if (data.id === this.loggedUserId) {
            //localStorage.removeItem('access_token');
            sessionStorage.removeItem('access_token');
            sessionStorage.removeItem('userCapability');
            sessionStorage.removeItem('otp');
            sessionStorage.removeItem('otp_date');
            sessionStorage.removeItem('lastTimeStamp');
            window.location.href = `${process.env.PUBLIC_URL || ""}/login`;
        }
    }


}
